import { Axios } from '@/utils/runtime_config';
import { Models } from '@mtap-smartcity/api';

export const get = async (): Promise<Models.Bff.Auth.Users.Model[]> => {
  const result = (await Axios.get<Models.Bff.Auth.Users.Model[]>('/api/auth/users')).data;
  return result;
};

export const getId = async (userId: string): Promise<Models.Bff.Auth.Users.Model> => {
  const result = (await Axios.get<Models.Bff.Auth.Users.Model>(`/api/auth/users/${userId}`)).data;
  return result;
};

export const post = async (payload: Models.Bff.Auth.Users.Model): Promise<Models.Bff.Auth.Users.Model> => {
  const result = (await Axios.post<Models.Bff.Auth.Users.Model>('/api/auth/users', payload)).data;
  return result;
};

export const putId = async (payload: Models.Bff.Auth.Users.Model): Promise<Models.Bff.Auth.Users.Model> => {
  const id = payload?.id;
  // delete payload.id
  const result = (await Axios.put<Models.Bff.Auth.Users.Model>(`/api/auth/users/${id}`, payload)).data;
  return result;
};

export const deleteId = async (id: string): Promise<void> => {
  const result = (await Axios.delete<void>(`/api/auth/users/${id}`)).data;
  return result;
};

export const putIdModifyGroups = async (payload: Models.Auth.Groups.GroupsModel): Promise<void> => {
  const result = (await Axios.put<void>(`/api/auth/users/${payload?.userId}/modify-groups`, payload)).data;
  return result;
};

export const putIdModifyRoles = async (payload: Models.Auth.Roles.RolesModel): Promise<void> => {
  const result = (await Axios.put<void>(`/api/auth/users/${payload?.userId}/modify-roles`)).data;
  return result;
};

export const putPassword = async (payload: Partial<Models.Bff.Auth.Users.Model>): Promise<void> => {
  const result = (await Axios.put<void>(`/api/auth/users/${payload?.id}/password`, payload)).data;
  return result;
};
